import React from 'react';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { getDatabase } from "firebase/database";
import { collection, addDoc, doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import NavBar from '../Components/NavBar';

const FormContainer = styled('form')(({ theme }) => ({
    '& .MuiTextField-root': {
        margin: theme.spacing(1),
        width: '60%',
    },
}));

function MakePost() {
    const [title, setTitle] = React.useState("");
    const [text, setText] = React.useState("");
    const [btext, setBText] = React.useState("");
    const [b2text, setB2Text] = React.useState("");
    const [time, setTime] = React.useState(Date().toString());
    const [yt, setYt] = React.useState("");
    const [topImg, setTopImg] = React.useState("");
    const [botImg, setBotImg] = React.useState("");
    const [tFile, setTFile] = React.useState(null);
    const [bFile, setBFile] = React.useState(null);
    const [tUrl, setTUrl] = React.useState("");
    const [bUrl, setBUrl] = React.useState("");

    var meta = {
        cacheControl: 'public,max-age=4000',
    };

    const handleSetTitle = (e) => {
        e.preventDefault();
        setTitle(e.target.value);
    }

    const handleSetYT = (e) => {
        e.preventDefault();
        setYt(e.target.value);
    }

    const handleSetText = (e) => {
        e.preventDefault();
        setText(e.target.value);
    }

    const handleSetTIMG = (e) => {
        e.preventDefault();
        setTopImg(e.target.value);
    }

    const handleSetBText = (e) => {
        e.preventDefault();
        setBText(e.target.value);
    }

    const handleSetBIMG = (e) => {
        e.preventDefault();
        setBotImg(e.target.value);
    }

    const handleSetB2Text = (e) => {
        e.preventDefault();
        setB2Text(e.target.value);
    }

    const handleChangeTFile = (e) => {
        e.preventDefault();
        if (e.target.files[0]) {
            setTFile(e.target.files[0]);
        }
    }
    const handleChangeBFile = (e) => {
        e.preventDefault();
        if (e.target.files[0]) {
            setBFile(e.target.files[0]);
        }
    }

    const handleTUpload = async (e) => {
		e.preventDefault();
        const storage = getStorage();
        const fileRef = ref(storage, tFile.name);
        await uploadBytes(fileRef, tFile, { customMetadata: meta });
        const url = await getDownloadURL(fileRef);
        setTUrl(url);
        setTopImg(url);
    };

    const handleBUpload = async (e) => {
		e.preventDefault();
        const storage = getStorage();
        const fileRef = ref(storage, bFile.name);
        await uploadBytes(fileRef, bFile, { customMetadata: meta });
        const url = await getDownloadURL(fileRef);
        setBUrl(url);
        setBotImg(url);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const docRef = await addDoc(collection(getDatabase, "Posts"), {
                Title: title,
                Text: text,
                Body_Text: btext,
                Body2_Text: b2text,
                T_IMG: topImg,
                B_IMG: botImg,
                YoutubeLink: yt,
            });
            
            console.log("Document written successfully");
            
            await setDoc(doc(getDatabase, "Posts", docRef.id), {
                Time: serverTimestamp()
            }, { merge: true });
            
            window.location.href = `/post/${docRef.id}`;
        } catch (error) {
            console.error("Error adding document: ", error);
        }
    }


    return(
        <>
            <NavBar/>
            <FormContainer noValidate autoComplete="off">
                <div className="editBox">
                    {/* Handle the Title attribute */}
                    <TextField id="standard-basic" label="Title" onChange={handleSetTitle} />
                    {/* Handle the YoutubeLink attribute */}
                    <TextField id="standard-basic" label="Youtube Link or Soundcloud Link?" onChange={handleSetYT} />
                    {/* Handle the Text attribute */}
                    <TextField
                        id="outlined-multiline-static"
                        label="Main Text Body"
                        multiline
                        rows={4}
                        variant="outlined"
                        onChange={handleSetText}
                    />
                    {/* Handle the T_IMG attribute */}
                    <input type="file" onChange={handleChangeTFile}/>
                    <button onClick={handleTUpload}>Upload</button>
                    <TextField id="standard-basic" label="Link to First Image?" value={!!tUrl ? (tUrl) : ""} onChange={handleSetTIMG} />
                    {/* Handle the Body_Text attribute */}
                    <TextField
                        id="outlined-multiline-static"
                        label="Second Text Body"
                        multiline
                        rows={4}
                        variant="outlined"
                        onChange={handleSetBText}
                    />
                    {/* Handle the B_IMG attribute */}
                    <input type="file" onChange={handleChangeBFile}/>
                    <button onClick={handleBUpload}>Upload</button>
                    <TextField id="standard-basic" label="Link to Second Image?" value={!!bUrl ? (bUrl) : ""} onChange={handleSetBIMG} />
                    {/* Handle the Body2_Text attribute */}
                    <TextField
                        id="outlined-multiline-static"
                        label="Bottom Text Body"
                        multiline
                        rows={4}
                        variant="outlined"
                        onChange={handleSetB2Text}
                    />
                    <Button onClick={handleSubmit} variant="contained" >Post</Button>
                </div>
            </FormContainer>
        </>
    )
}

export default MakePost;
